import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useTranslation } from 'react-i18next';
import {
  PaymentElement,
  useElements,
  useStripe,
} from '@stripe/react-stripe-js';
import { useCreatePaymentIntentMutation } from 'services/payments/api';
import envvars from 'utils/envvars';

const CheckoutForm = () => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const [createPaymentIntent] = useCreatePaymentIntentMutation();

  const handleSubmit = async e => {
    e.preventDefault();

    if (elements == null) {
      return;
    }

    const { error: submitError } = await elements.submit();
    if (submitError) {
      setErrorMessage(submitError.message || null);
      return;
    }

    const clientSecret = await createPaymentIntent()
      .then(({ data }) => data);

    if (stripe && clientSecret) {
      const { error } = await stripe.confirmPayment({
        elements,
        clientSecret,
        confirmParams: {
          return_url: envvars.stripeConfirmationUrl,
        },
      });
  
      if (error) {
        setErrorMessage(error.message || null);
      } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Button
        disabled={!stripe || !elements}
        onClick={e => handleSubmit(e)}
        style={{
          float: 'right',
        }}
        variant="success"
      >
        {t('pay')}
      </Button>
      {
        errorMessage && <div>{errorMessage}</div>
      }
    </form>
  );
};

export default CheckoutForm;
